import {
    Grid
} from '@mui/material';
import {
    makeStyles
} from "@mui/styles";
import MinimizeIcon from '@mui/icons-material/Minimize';
import SettingsOverscanIcon from '@mui/icons-material/SettingsOverscan';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import MicOffIcon from '@mui/icons-material/MicOff';
import PauseIcon from '@mui/icons-material/Pause';
import DialpadIcon from '@mui/icons-material/Dialpad';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CustomTimer from "./CustomTimer";
import ClickAwayListener from 'react-click-away-listener';
import { useState } from 'react';

const useStyles = makeStyles({
    callPopup: {
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 1,
        border: "1px solid #1f1f1f",
        backgroundColor: "#1f1f1f",
        padding: "10px 20px"
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    topBtn: {
        border: "none",
        backgroundColor: "#1f1f1f",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "30px",
        paddingBottom: "15px",
        marginLeft: "10px",
        cursor: "pointer"
    },
    maximize: {
        paddingBottom: "0px"
    },
    middleSection: {
        marginTop: "10px",
        backgroundColor: "#272727",
        boxShadow: "0px 4px 4px 4px #00000040",
        borderRadius: "10px",
        padding: "10px",
        paddingTop: "10%",
        textAlign: "center",
        height: "calc(100vh - 125px)",
        overflow: "scroll"
    },
    avatar: {
        width: "120px",
        height: "120px"
    },
    callerName: {
        color: "white",
        margin: 0
    },
    status: {
        color: "#999999",
        margin: 0,
        marginTop: "10px"
    },
    bottomRow: {
        marginTop: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    muteIcon: {
        color: "white"
    },
    dialpadIcon: {
        height: "20px"
    },
    dialpadView: {
        position: "relative"
    },
    dialpad: {
        backgroundColor: "white",
        position: "absolute",
        bottom: "40px",
        left: "50%",
        transform: "translate(-50%, 0)",
        border: "1px solid #00000038",
        borderRadius: "10px",
        boxShadow: "0px 0px 5px 0px #00000040",
        overflow: "hidden"
    },
    dialpadRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    dtmfRow: {
        height: "42px",
        borderBottom: "1px solid #00000038"
    },
    dialpadNumberInput: {
        width: "100%",
        margin: "0px",
        padding: "10px",
        fontSize: "18px",
        textAlign: "center"
    },
    dialpadBtn: {
        borderRadius: 0,
        border: 0,
        padding: "20px 30px",
        cursor: "pointer",
        fontSize: "18px",
        backgroundColor: "white"
    },
    iconView: {
        backgroundColor: "#272727",
        color: "white",
        height: "35px",
        width: "35px",
        borderRadius: "50%",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        margin: "0px 5px"
    },
    hangupBtn: {
        marginLeft: "5px",
        height: "35px",
        border: "none",
        padding: "0px",
        borderRadius: "20px",
        cursor: "pointer"
    },
    hangupIcon: {
        height: "35px"
    }
});

const CallPopup = ({
    session,
    callAnswered,
    onAnswerCall,
    onHangupCall,
    toggleMute,
    toggleHold,
    type,
    callerName,
    callerNumber,
    sendDTMF,
    isMute,
    isHold
}) => {
    const classes = useStyles();

    const [dialpadIsVisible, setDialpadIsVisible] = useState(false);
    const [dtmfNumber, setDtmfNumber] = useState("");

    const onDialpadNumberClicked = (number) => {
        setDtmfNumber(dtmfNumber.concat(number));
        sendDTMF(number);
    }

    return (
        <Grid className={classes.callPopup}>
            <Grid className={classes.toolbar}>
                <button
                    className={classes.topBtn}
                >
                    <MinimizeIcon />
                </button>
                <button
                    className={[classes.topBtn, classes.maximize].join(' ')}
                >
                    <SettingsOverscanIcon sx={{ fontSize: "20px" }} />
                </button>
                <button
                    onClick={onHangupCall}
                    className={[classes.topBtn, classes.maximize].join(' ')}
                >
                    <CloseIcon />
                </button>
            </Grid>
            <Grid
                className={classes.middleSection}
            >
                <img
                    src={require("../../assets/icons/userAvatar.png")}
                    className={classes.avatar}
                />
                <h2 className={classes.callerName}>{callerName}</h2>
                {
                    callAnswered ?
                        <CustomTimer />
                        :
                        <p className={classes.status}>Ringing...</p>
                }
            </Grid>
            <Grid
                className={classes.bottomRow}
            >
                <Grid className={classes.dialpadView}>
                    <button
                        onClick={() => setDialpadIsVisible(true)}
                        className={classes.iconView}
                    >
                        <DialpadIcon
                            className={classes.dialpadIcon}
                        />
                    </button>
                    {
                        dialpadIsVisible ?
                            <ClickAwayListener onClickAway={() => setDialpadIsVisible(false)}>
                                <Grid className={classes.dialpad}>
                                    <Grid className={[classes.dialpadRow, classes.dtmfRow]}>
                                        <p className={classes.dialpadNumberInput}>{dtmfNumber}</p>
                                    </Grid>
                                    <Grid className={classes.dialpadRow}>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="1"
                                            onClick={() => onDialpadNumberClicked("1")}
                                        >1</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="2"
                                            onClick={() => onDialpadNumberClicked("2")}
                                        >2</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="3"
                                            onClick={() => onDialpadNumberClicked("3")}
                                        >3</button>
                                    </Grid>
                                    <Grid className={classes.dialpadRow}>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="4"
                                            onClick={() => onDialpadNumberClicked("4")}
                                        >4</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="5"
                                            onClick={() => onDialpadNumberClicked("5")}
                                        >5</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="6"
                                            onClick={() => onDialpadNumberClicked("6")}
                                        >6</button>
                                    </Grid>
                                    <Grid className={classes.dialpadRow}>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="7"
                                            onClick={() => onDialpadNumberClicked("7")}
                                        >7</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="8"
                                            onClick={() => onDialpadNumberClicked("8")}
                                        >8</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="9"
                                            onClick={() => onDialpadNumberClicked("9")}
                                        >9</button>
                                    </Grid>
                                    <Grid className={classes.dialpadRow}>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="*"
                                            onClick={() => onDialpadNumberClicked("*")}
                                        >*</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="0"
                                            onClick={() => onDialpadNumberClicked("0")}
                                        >0</button>
                                        <button
                                            className={classes.dialpadBtn}
                                            value="#"
                                            onClick={() => onDialpadNumberClicked("#")}
                                        >#</button>
                                    </Grid>
                                </Grid>
                            </ClickAwayListener>
                            :
                            <></>
                    }
                </Grid>
                <button
                    onClick={toggleHold}
                    className={classes.iconView}
                >
                    {
                        isHold ?
                            <PlayArrowIcon
                                className={classes.muteIcon}
                            />
                            :
                            <PauseIcon
                                className={classes.muteIcon}
                            />
                    }
                </button>
                <button
                    onClick={toggleMute}
                    className={classes.iconView}
                >
                    {
                        isMute ?
                            <MicOffIcon
                                className={classes.muteIcon}
                            />
                            :
                            <KeyboardVoiceIcon
                                className={classes.muteIcon}
                            />
                    }
                </button>
                <button
                    className={classes.hangupBtn}
                    onClick={onHangupCall}
                >
                    <img
                        src={require("../../assets/icons/hangup.png")}
                        className={classes.hangupIcon}
                    />
                </button>
            </Grid>
        </Grid>
    )
}

export default CallPopup;